export default __webpack_public_path__ + "static/media/welcomLogo.50d61e1e.svg";